import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { WindowService } from 'src/app/services/local/window.service';
import { storageKeys } from 'src/app/share/configs';

@Component({
  selector: 'uo-checkout-header',
  templateUrl: './checkout-header.component.html',
  styleUrls: ['./checkout-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutHeaderComponent implements OnInit {
  constructor(private winServe: WindowService, private router: Router) {}

  ngOnInit(): void {
    // No initialization needed
  }

  navigateToRestaurant(): void {
    // Fetch storeId from localStorage at the time of click
    const storeId = this.winServe.getLocalStorage(storageKeys.store);
    if (storeId) {
      this.router.navigate(['/store', storeId]);
    } else {
      console.error('Store ID not found in localStorage');
      // Fallback to home page if no store ID
      this.router.navigate(['/home']);
    }
  }
}
